import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal';
import cl from '../Form.module.css';
import Plus from "../../../../assets/Icon/Plus";
import { useTranslation } from 'react-i18next';

const resetData = {
    name: "",
    phone: "",
    email: "",
    file: "",
    file_upload: null,
};

const AddAgentCRMModal = ({ agentCRMService }) => {
    const { t } = useTranslation();
    const [newAgent, setNewAgent] = useState(resetData);
    const [isFirstValidated, setIsFirstValidated] = useState(false);
    const [validates, setValidates] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);

    const validateAgent = (agent) => {
        const messages = {};

        if (agent.name.length < 2) {
            messages.name = { message: 'მიუთითეთ დასახელება', isValid: false };
        }

        if (agent.phone.length < 2) {
            messages.phone = { message: 'მიუთითეთ ტელეფონი', isValid: false };
        }

        setValidates(messages);
        return Object.keys(messages).length === 0;
    };

    useEffect(() => {
        if (isFirstValidated) {
            validateAgent(newAgent);
        }
    }, [newAgent, isFirstValidated]);

    const saveHandle = () => {
        if (validateAgent(newAgent)) {
            agentCRMService.add(newAgent);
            setIsModalOpen(false);
        } else {
            setIsFirstValidated(true);
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setNewAgent(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (event) => {
        const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
        setNewAgent(prev => ({ ...prev, file_upload: file }));
    };

    const openAdd = () => {
        setValidates({});
        setIsModalOpen(true);
        setIsFirstValidated(false);
        setNewAgent(resetData);
    };

    return (
        <div>
            <span onClick={openAdd} className={cl.AddBtn}>
                <span className={cl.icon}><Plus /></span>
                {t('Add')}
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead}>
                    <h3><span className={cl.iconHead}><Plus /></span>{t('Add')}</h3>
                </div>

                <div className={cl.groupInput}>
                    <label>{t('Name')}</label>
                    <input type="text" className={validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="name"
                        value={newAgent.name}
                        onChange={handleChange}
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}>
                    <label>{t('Phone')}</label>
                    <input type="text" className={validates.phone ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="phone"
                        value={newAgent.phone}
                        onChange={handleChange}
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}>
                    <label>{t('Email')}</label>
                    <input type="email" className={cl.input}
                        name="email"
                        value={newAgent.email}
                        onChange={handleChange}
                        autoComplete="off" />
                </div>

                <div className={cl.groupInput}>
                    <label>{t('File')}</label>
                    <input type="file" className={cl.input}
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp"
                        onChange={handleFileChange} />
                </div>

                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Add')}</span>
            </Modal>
        </div>
    );
};

export default AddAgentCRMModal;
